import React from 'react'
import { Route, Redirect, useParams } from 'react-router-dom'
import propTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Header from '../../components/Mobile/Header'

function PublicRoute({ component: Component, ...rest }) {
  const user = useSelector((state) => state.login.user)
  const authed = !!(localStorage.getItem('jwtToken')
  && localStorage.getItem('user')
  && user
  && user.roll !== 'user'
  )
  // console.log('Authed at public route = ', authed)
  return (
    <Route
      { ...rest }
      render={ (props) => (authed ? (
        <>
          <Header />
          <Component { ...props } />
        </>
      ) : (
        <>
          <Header />
          <Component { ...props } />
        </>
      )
      ) }
    />
  )
}

PublicRoute.propTypes = {
  component: propTypes.node.isRequired,
}

export default PublicRoute
